module.exports = __webpack_public_path__ + "img/banner_online_KR.cc40e1b8.png";